/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S11_Qnb_BodyInputs */

const tr_mesafeli_s11_qnb_body = /** @type {(inputs: Mesafeli_S11_Qnb_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura / e-Arşiv entegrasyonu.`)
};

const en_mesafeli_s11_qnb_body = /** @type {(inputs: Mesafeli_S11_Qnb_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura / e-Arşiv integration.`)
};

const de_mesafeli_s11_qnb_body = /** @type {(inputs: Mesafeli_S11_Qnb_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura / e-Arşiv Integration.`)
};

const ru_mesafeli_s11_qnb_body = /** @type {(inputs: Mesafeli_S11_Qnb_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интеграция e-Fatura / e-Arşiv.`)
};

/**
* | output |
* | --- |
* | "e-Fatura / e-Arşiv integration." |
*
* @param {Mesafeli_S11_Qnb_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s11_qnb_body = /** @type {((inputs?: Mesafeli_S11_Qnb_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S11_Qnb_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s11_qnb_body(inputs)
	if (locale === "de") return de_mesafeli_s11_qnb_body(inputs)
	if (locale === "ru") return ru_mesafeli_s11_qnb_body(inputs)
	return tr_mesafeli_s11_qnb_body(inputs)
});